// src/pages/Dashboard/components/DashboardCharts.js

import React from "react";
import { Pie, Bar } from "react-chartjs-2";
import { FaEye } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

// Co-locating ChartCard here
const ChartCard = ({
  title,
  children,
  className = "",
  actionButton,
  loading = false,
}) => (
  <div
    className={`bg-white rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-all duration-300 p-6 ${className}`}
  >
    <div className="flex items-center justify-between mb-6">
      <h3 className="text-xl font-semibold text-gray-900 flex items-center">
        <div className="w-1 h-6 bg-gradient-to-b from-blue-500 to-purple-600 rounded-full mr-3"></div>
        {title}
      </h3>
      {actionButton && actionButton}
    </div>
    <div className="h-64">
      {loading ? (
        <div className="h-full bg-gray-100 rounded-lg animate-pulse flex items-center justify-center">
          <div className="text-gray-400 text-sm">Loading chart...</div>
        </div>
      ) : (
        children
      )}
    </div>
  </div>
);

const DashboardCharts = ({
  pieChartData,
  barChartData,
  pieChartOptions,
  barChartOptions,
  transactionsLoading,
}) => {
  const navigate = useNavigate();

  return (
    <section className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
      <ChartCard
        title="Today's Oil Change Distribution"
        loading={transactionsLoading}
        actionButton={
          <button
            className="text-blue-600 hover:text-blue-700 font-medium text-sm hover:bg-blue-50 px-3 py-1 rounded-lg transition-colors"
            onClick={() => navigate("/reports")}
          >
            <FaEye className="inline mr-1" />
            View Details
          </button>
        }
      >
        <Pie data={pieChartData} options={pieChartOptions} />
      </ChartCard>
      <ChartCard
        title="Today's Other Services"
        loading={transactionsLoading}
        actionButton={
          <button
            className="text-blue-600 hover:text-blue-700 font-medium text-sm hover:bg-blue-50 px-3 py-1 rounded-lg transition-colors"
            onClick={() => navigate("/reports")}
          >
            <FaEye className="inline mr-1" />
            View Details
          </button>
        }
      >
        <Bar data={barChartData} options={barChartOptions} />
      </ChartCard>
    </section>
  );
};

export default DashboardCharts;